import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  Error,
  GetAiModelResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onError?: (error: Error) => void
  onSuccess?: (response: GetAiModelResponse) => void
  children?: (response: GetAiModelResponse) => ReactElement | null
  shortErrorMessage?: string
  id: string
  hasSpinner?: boolean
}

const GetAiModelRequest = ({
  id,
  onError,
  onSuccess,
  children,
  shortErrorMessage,
  hasSpinner = true
}: Props) => {
  const url = `${AI_API_SERVICE}/models/${id}`

  const spinnerSize = !hasSpinner
    ? 0
    : undefined

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      shortErrorMessage={shortErrorMessage}
      spinnerSize={spinnerSize}
      url={url}
    />
  )
}

export default GetAiModelRequest
